// RTK Query base API configuration

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'
import { API_BASE_URL } from '@/constants'
import { storageService } from '@/services'

// Base query with auth token
const baseQuery = fetchBaseQuery({
  baseUrl: API_BASE_URL,
  prepareHeaders: (headers) => {
    const token = storageService.getAuthToken()
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    headers.set('Content-Type', 'application/json')
    return headers
  },
})

// Base query with re-auth logic
const baseQueryWithReauth: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions)

  // Handle 401 Unauthorized errors
  if (result.error && result.error.status === 401) {
    // Clear auth tokens
    storageService.removeAuthTokens()
    storageService.removeUser()

    // Redirect to login page if not already there
    if (!window.location.pathname.includes('/login')) {
      window.location.href = '/login'
    }
  }

  return result
}

// Base API
export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Auth',
    'User',
    'Farm',
    'Cow',
    'Transaction',
    'Budget',
    'Behavior',
    'BehaviorSummary',
    'BehaviorTrends',
    'Estrus',
    'Notification',
    'NotificationPreferences',
    'AlertRule',
    'FarmerProfile',
    'FarmerDashboard',
    'FarmStatistics',
    'DashboardPreferences',
    'HeatAlert',
  ],
  endpoints: () => ({}),
})
